import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";

// Route guard for the administration pages. Reads ``is_admin`` and
// ``is_developer`` of the signed-in user from api/user/profile/ and sends
// everybody else back to the home page. Users is for administrators; System
// (``developers``) is for administrators and developers. The backend enforces
// the same rules on api/admin/ (userapp.user_admin.IsAppAdmin and
// IsAppAdminOrDeveloper); this guard only keeps a page from rendering into
// a 403.
//
// Renders nothing while the lookup is pending.
/** The signed-in account's rights, plus its first name for the side menu
 *  (one request serves both). */
export function fetchRights() {
  return axios.get("api/user/profile/").then((res) => ({
    isAdmin: Boolean(res?.data?.is_admin),
    isDeveloper: Boolean(res?.data?.is_developer),
    firstName: res?.data?.first_name || "",
  }));
}

export function fetchIsAdmin() {
  return fetchRights().then((rights) => rights.isAdmin);
}

export default function AdminRoute({ developers = false }) {
  const [state, setState] = useState("pending"); // pending | granted | denied | unauthenticated

  useEffect(() => {
    let cancelled = false;
    fetchRights()
      .then(({ isAdmin, isDeveloper }) => {
        const granted = isAdmin || (developers && isDeveloper);
        if (!cancelled) setState(granted ? "granted" : "denied");
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setState(err?.response?.status === 401 ? "unauthenticated" : "denied");
      });
    return () => {
      cancelled = true;
    };
  }, [developers]);

  if (state === "unauthenticated") return <Navigate to="/login" replace />;
  if (state === "pending") return null;
  if (state === "denied") return <Navigate to="/" replace />;
  return <Outlet />;
}
